


export interface SecurityStore {
    has: () => boolean
    // set: （query: Query) => void
    // get: (queryHash: string) => Query | undefined
    // delete: (queryHash: string) => void
}
export class SecurityStore {

    get() {

    }
    save() {

    }
    clear() {

    }
}